export default __webpack_public_path__ + "static/zen-advisor-header-8c5bf6efcd57c25d463628821fbe9d14.jpg";